export const setBarStatus = (context, payload) => {
	context.commit('setBarStatus', payload);
};

export const setModalData = (context, payload) => {
	context.commit('setModalData', payload);
};

export const setToken = (context, payload) => {
	context.commit('setToken', payload);
};

export const setLogUser = (context, payload) => {
	context.commit('setLogUser', payload);
};

export const setUser = (context, payload) => {
	context.commit('setUser', payload);
};

export const logoff = (context, payload) => {
	context.commit('logoff', payload);
};

export const setDatabase = (context, payload) => {
	context.commit('setDatabase', payload);
};
export const setModalPessoa = (context, payload) => {
	context.commit('setModalPessoa', payload);
};

export const setModalPagamento = (context, payload) => {
	context.commit('setModalPagamento', payload);
};

export const setEditModalPagamento = (context, payload) => {
	context.commit('setPedidoEditModalPagamento', payload);
};

export const setPedidoDataDetail = (context, payload) => {
	context.commit('setPedidoDataDetail', payload);
};

export const setModalCondPagamento = (context, payload) => {
	context.commit('setModalCondPagamento', payload);
};

export const setEditModalTabVendas = (context, payload) => {
	context.commit('setEditModalTabVendas', payload);
};

export const setAddModalTabVendas = (context, payload) => {
	context.commit('setAddModalTabVendas', payload);
};

export const setGlobalPickerDate = (context, payload) => {
	context.commit('setGlobalPickerDate', payload);
};

export const setUpdateAdmUserTable = (context, payload) => {
	context.commit('setUpdateAdmUserTable', payload);
};
